export default {
  "list-item": "_list-item_1a2rdz",
  "is-current": "_is-current_1a2rdz",
  "organization-logo": "_organization-logo_1a2rdz",
  "organization-name": "_organization-name_1a2rdz",
  "icons": "_icons_1a2rdz",
  "cbs": "_cbs_1a2rdz"
};
